export const BONE = '#dde0e5'
export const DARK = '#0f1521'
export const ERROR_RED = '#e74d3d'
export const PINE_GREEN = '#1abc9d'
export const SLATE = '#475166'
